import { render, staticRenderFns } from "./MasterAkses_magister.vue?vue&type=template&id=8671404e"
import script from "./MasterAkses_magister.vue?vue&type=script&lang=js"
export * from "./MasterAkses_magister.vue?vue&type=script&lang=js"
import style0 from "./MasterAkses_magister.vue?vue&type=style&index=0&id=8671404e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports